import React from 'react';
import { Redirect } from 'react-router-dom';
import { AccountErrorMessage } from '../components/AccountErrorMessage';
import EnterpriseAccountMembers from '../components/EnterpriseAccountMembers';
import EnterpriseAccountOverview from '../components/EnterpriseAccountOverview';
import EnterpriseAccountPayments from '../components/EnterpriseAccountPayments';
import { EnterpriseDashboardLayout } from '../components/templates/EnterpriseDashboardLayout';
import { useAccountContext } from '../context/AccountContext';

const EnterpriseAccountPage: React.FC = () => {
  const { account, organization, organizationError, loading, loadingState } =
    useAccountContext();
  const signedOut = !loading && !account;
  const isNotAnAdmin = !loading && !organization;

  // stay on the page (rather than redirecting) so the URL's params are kept
  if (loadingState === 'error') {
    return (
      <div className="px-6 py-10">
        <AccountErrorMessage />
      </div>
    );
  }

  return (signedOut || isNotAnAdmin) && !organizationError ? (
    <Redirect to="/account" />
  ) : (
    <EnterpriseDashboardLayout
      routes={[
        {
          path: '/overview',
          label: 'Overview',
          content: EnterpriseAccountOverview,
        },
        {
          path: '/members',
          label: 'Manage members',
          content: EnterpriseAccountMembers,
        },
        {
          path: '/payment',
          label: 'Payment history',
          content: EnterpriseAccountPayments,
        },
      ]}
    />
  );
};

export default EnterpriseAccountPage;
